module.exports = __webpack_public_path__ + "media/music/piano_2-490568e1.mp3";